exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#pufferfish .prompt-list .aqe-well .aqe-well-body .aqe-well-body-wrapper{display:block}#pufferfish .prompt-list .page-header-right{text-align:right}", ""]);
